import React from "react";

const SpeakProRoute = ({ children }) => {
    return children;
};

export default SpeakProRoute;
